import {Variable} from '@packages/systems/wfdl';
import {pageVariable} from '@packages/shared/constants/Render';
import {type BindingIdAndPath} from '@packages/systems/ExpressionEditor-utils';

const isPageRef = Variable.equals(pageVariable);

/**
 * Returns true when a binding points specifically to `currentPage.name`.
 */
export const isCurrentPageNameBinding = (
  binding: BindingIdAndPath | null | undefined
): boolean =>
  Boolean(
    binding &&
    isPageRef(binding.id) &&
    binding.path.length === 1 &&
    binding.path[0] === 'name'
  );
